import { Input } from "antd";
import React, {useState} from "react";
import styled from "styled-components";
import { CloseEyeIcon, OpenEyeIcon } from "@assets";

const PasswordInput = styled(Input.Password)`
  border-radius: 16px !important;
  background: #D9D9D9;

  height: 48px;
  &::placeholder {
    margin-left: 16px;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #0000004D;
  }

   input {
    text-align: left !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    background: #D9D9D9;
    color: #000;
  }
  
  &&& {
    border-radius: 26px;
    text-align: center !important;
    padding-left: 17px;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

const InputPassword = ({ value , placeholder, ...props }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  const handleKeyDown = (event) => {
    const key = event.key;
    const isAllowedKey = /^[0-9\b]+$/.test(key);
    if (!isAllowedKey && key !== "Backspace") {
      event.preventDefault();
    }
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const renderIcon = () => {
    return (
      <div style={{marginTop: 6}}>
       { 
        !value ? ''
          : isVisible ? <OpenEyeIcon onClick={toggleVisibility}/> 
          : <CloseEyeIcon onClick={toggleVisibility}/> 
        }
      </div>
    )
  }

  return (

    <PasswordInput 
      size="large"
      placeholder={placeholder}
      onKeyDown={handleKeyDown}
      iconRender={renderIcon}
      {...props}
    />
  );
};

export default InputPassword;
